import { useEffect, useRef, useCallback } from 'react';

export function useScrollReveal() {
  const ref = useRef<HTMLDivElement>(null);

  const handleReveal = useCallback(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.88) {
      ref.current.classList.add('revealed');
    }
  }, []);

  useEffect(() => {
    handleReveal();
    window.addEventListener('scroll', handleReveal, { passive: true });
    return () => window.removeEventListener('scroll', handleReveal);
  }, [handleReveal]);

  return ref;
}
